import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useCreateChat } from '@services/chat/mutations/useCreateChat'

interface Props {
  user?: string
  onCreated: (id: string) => void
}

export function NewConversation({ user, onCreated }: Props) {
  const { t } = useTranslation('chat')
  const createChat = useCreateChat<'ADMIN'>()
  const [title, setTitle] = useState('')

  const submit = () => {
    if (!title.trim()) return
    createChat.mutate(
      { body: { title: title.trim(), ...(user ? { user } : {}) } },
      { onSuccess: (data) => data?.id && onCreated(data.id) }
    )
  }

  return (
    <div className="flex flex-1 flex-col p-4">
      <Label className="mb-2">{t('form.labels.title')}</Label>
      <Input
        autoFocus
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && submit()}
        placeholder={t('form.common.placeholder')}
      />
      <Button
        className="mt-4 self-start"
        onClick={submit}
        disabled={!title.trim() || createChat.isPending}
      >
        {t('form.labels.create')}
      </Button>
    </div>
  )
}
